import { Switch, Redirect, Route } from 'react-router-dom';

import { useInitializeLiveChat } from '@/app/liveChat/_hooks';
import { useMixpanelPageViews } from '@/app/mixpanel/_hooks';
import AuthenticationWrapper from '@/app/authentication/AuthenticationWrapper';
import Navigation from '@/app/navigation/Navigation';
import ViewFeatureAnnouncements from '@/app/product/ViewFeatureAnnouncements';
import ComparisonRoutes from '@/app/comparison/Routes';
import MarketRoutes from '@/app/market/Routes';
import ProductRoutes from '@/app/product/Routes';
import ProjectRoutes from '@/app/project/Routes';
import ProjectRecordRoutes from '@/app/projectRecord/Routes';
import EstimateRoutes from '@/app/estimate/Routes';
import UnitCostCatalogFactRoutes from '@/app/unitCostCatalogFact/Routes';
import SettingsRoutes from '@/app/settings/Routes';
import ProfileRoutes from '@/app/user/Routes';
import LoginRoutes from '@/app/login/Routes';
import AccountSetupRoutes from '@/app/accountSetup/Routes';
import DashboardRoutes from '@/app/dashboard/Routes';
import PreconRoutes from '@/app/precon/Routes';
import Auth0Routes from '@/app/auth0/Routes';
import ProcoreIntegrationMappingRoutes from '@/app/procoreIntegrationMapping/Routes';
import HelpArticleRoutes from '@/app/helpArticle/Routes';

const App = () => {
  useInitializeLiveChat();
  useMixpanelPageViews();

  return (
    <Switch>
      <Redirect exact from="/" to="/dashboard" />

      <Route path="/users/activate" component={AccountSetupRoutes} />
      <Route path="/auth0" component={Auth0Routes} />
      <Route path="/login" component={LoginRoutes} />

      <AuthenticationWrapper>
        <Navigation />
        <ViewFeatureAnnouncements />
        <div className="pl-(--app-nav-width)">
          <Route path="/dashboard" component={DashboardRoutes} />
          <Route path="/precon" component={PreconRoutes} />
          <Route path="/comparison" component={ComparisonRoutes} />
          <Route path="/market" component={MarketRoutes} />
          <Route path="/product" component={ProductRoutes} />
          <Route path="/project" component={ProjectRoutes} />
          <Route path="/project-record" component={ProjectRecordRoutes} />
          <Route path="/estimate" component={EstimateRoutes} />
          <Route path="/unit-cost-history" component={UnitCostCatalogFactRoutes} />
          {/* The page lived at /unit-cost-catalog before it took the Unit Cost History name;
              old links land on the same sub-path with their filters kept. */}
          <Route
            path="/unit-cost-catalog"
            render={({ location }) => <Redirect to={{ ...location, pathname: location.pathname.replace(/^\/unit-cost-catalog/, '/unit-cost-history') }} />}
          />
          <Route path="/settings" component={SettingsRoutes} />
          <Route path="/profile" component={ProfileRoutes} />
          <Route path="/procore-integration-mapping" component={ProcoreIntegrationMappingRoutes} />
          <Route path="/help" component={HelpArticleRoutes} />
        </div>
      </AuthenticationWrapper>
    </Switch>
  );
};

export default App;
